module.exports = __webpack_public_path__ + "img/parado_slim_bl_007.a6e4c9d1.jpg";